module.exports = __webpack_public_path__ + "static/media/dijete.4fd7a3c7.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/dijete.jpg
 ** module id = 282
 ** module chunks = 0
 **/